import React from "react";
import LogoutIcon from "@mui/icons-material/Logout";

import { Box } from "../elements";

export function Logout({ data, onClick }) {
  return (
    <Box style={styles.wrapper}>
      <button type="button" style={styles.logout} onClick={onClick}>
        <LogoutIcon fontSize="small" />
        <span style={styles.text}>{data.text}</span>
      </button>
    </Box>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "50px",
  },
  logout: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    height: "36px",
    width: "100px",
    color: "#000",
    cursor: "pointer",
    transition: "background-color 0.2s",
    background: "none",
    border: "none",
    padding: 0,
  },
  text: {
    fontSize: "14px",
    fontWeight: 500,
    letterSpacing: "1px",
    textTransform: "capitalize",
  },
};
